import common from "../common";

export default class BoardGraphicGenerator 
{
    constructor()
    {
        this.pixi = null;

        this.textRestrictedColours = [{r:255, g:204, b:1}, {r:200, g:16, b:46}];

        this.boardStructure = [
            {y:21, h:40, cols:[{x:1, w:8}, {x:11, w:25}, {x:28, w:42}, {x:45, w:59}, {x:62, w:77}, {x:80, w:94}, {x:97, w:111}, {x:114, w:128}, {x:131, w:138}]},
            {y:42, h:70, cols:[{x:1, w:7}, {x:10, w:23}, {x:26, w:40}, {x:43, w:50}, {x:53, w:68}, {x:71, w:86}, {x:89, w:96}, {x:99, w:113}, {x:116, w:129}, {x:132, w:138}]},
            //{y:71, h:87, cols:[{x:1, w:5}, {x:12, w:21}, {x:28, w:36}, {x:43, w:50}, {x:57, w:66}, {x:73, w:82}, {x:89, w:96}, {x:103, w:111}, {x:118, w:127}, {x:134, w:138}]}
        ];

        this.init();
    }

    init()
    {
        this.pixi = new PIXI.Application({width: 140, height: 88});
        document.body.appendChild(this.pixi.view);

        var text1 = new PIXI.Text("text", {fontFamily : 'Man United', fontSize: 12, fill: 0xffcc00});
        this.pixi.stage.addChild(text1);
        var text2 = new PIXI.Text("text", {fontFamily : 'Delivery Condensed Black', fontSize: 12, fill : 0xffcc00});
        this.pixi.stage.addChild(text2);

        if(!this.pixi.renderer.gl)
        {
            MEDIATOR.redirectToBasicMode();
        }

        for(var i in this.boardStructure)
        {
            this.boardStructure[i].h = this.boardStructure[i].h - this.boardStructure[i].y;
            for(var j in this.boardStructure[i].cols)
            {
                this.boardStructure[i].cols[j].w = this.boardStructure[i].cols[j].w - this.boardStructure[i].cols[j].x;
            }
        }
    }

    getPixelsFromImage(url, callback)
    {
        if(PIXI.loader.resources[url] == undefined)
        {
            console.log('new image');
            PIXI.loader.add(url).load(() => {
                callback(this.addImageAndGetPixels(url));
            });
        }
        else
        {
            console.log('old image');
            console.log(PIXI.loader.resources);
            callback(this.addImageAndGetPixels(url));
        }
    }

    addImageAndGetPixels(url)
    {
        var image = new PIXI.Sprite(PIXI.loader.resources[url].texture);
        this.pixi.stage.addChild(image);
        var pixels = this.pixi.renderer.plugins.extract.pixels(this.pixi.stage);
        return pixels;
    }

    getPixelsFromText(text, callback)
    {
        console.log('getPixelsFromText');

        var holder = new PIXI.Container();
        this.pixi.stage.addChild(holder);

        var bg = new PIXI.Graphics();
        bg.beginFill(0xffcc00);
        bg.drawRect(0, 0, 140, 88);
        holder.addChild(bg);

        var mask = new PIXI.Graphics();
        mask.beginFill(0xffcc00);
        mask.drawRect(0, 0, 140, 88);
        holder.mask = mask;

        var lines = text.split('\n');

        var row = 0;
        var col = 0;

        for(var i in lines)
        {
            if(lines[i].length > this.boardStructure[row].cols.length)
            {
                lines[i] = lines[i].split(" ")[0];
            }
            if(lines[i].length <= this.boardStructure[row].cols.length)
            {
                col = Math.round((this.boardStructure[row].cols.length - lines[i].length) / 2);

                for(var j in lines[i])
                {
                    var pt = new PIXI.Text(lines[i][j].toUpperCase(), {fontFamily : 'Delivery Condensed Black', fontSize: 21, fill : 0xd1010f, align : 'center'});
                    console.log(pt.width, pt.height);
                    pt.x = this.boardStructure[row].cols[col].x + ((this.boardStructure[row].cols[col].w - pt.width) / 2);
                    pt.y = this.boardStructure[row].y;
                    holder.addChild(pt);
                    col++;
                    if(this.boardStructure[row].cols[col] == undefined)
                    {
                        break;
                    }
                }
            }
            row++;
            col = 0;

            if(this.boardStructure[row] == undefined)
                break;
        }

        setTimeout(() => 
        {
            var basePixels = this.pixi.renderer.plugins.extract.pixels(this.pixi.stage); 

            var pixels;
            if(common.country == 'ja' || common.country == 'ko' || common.country == 'zh' || common.country == 'ar')
            {
                pixels = this.dualColours(basePixels, this.textRestrictedColours[0], this.textRestrictedColours[1]);
            }
            else
            {
                pixels = this.restrictColours(basePixels, this.textRestrictedColours);
            } 
            
            console.log(pixels);
            console.log(this.pixi.renderer.plugins.extract.base64(this.pixi.stage));
            callback(pixels);
        }, 200);
    }

    getPixelsFromPlayer(playerNumber, callback)
    {
        var holder = new PIXI.Container();
        this.pixi.stage.addChild(holder);

        var bg = new PIXI.Graphics();
        bg.beginFill(0xd40112);
        bg.drawRect(0, 0, 140, 88);
        holder.addChild(bg);

        var font = 'Man United';
        var fontSize = 90;
        /*if(common.isMac && (String(playerNumber).indexOf('6') > -1 || String(playerNumber).indexOf('9') > -1))
        {
            font = 'Delivery Condensed Black';
            fontSize = 80;
        }*/

        var pt = new PIXI.Text(playerNumber, {fontFamily : font, fontWeight:'bold', fontSize: fontSize, fill : 0xffffff, align : 'left'});
        pt.x = 90 - (pt.width/2) - 19;
        pt.y = 44 - (pt.height/2);
        holder.addChild(pt);

        setTimeout(() => 
        {
            var pixels = this.restrictColours(
                this.pixi.renderer.plugins.extract.pixels(this.pixi.stage),
                [{r:255, g:255, b:255}, {r:200, g:16, b:46}]
            );
            console.log(this.pixi.renderer.plugins.extract.base64(this.pixi.stage));
            callback(pixels);
        }, 200);
    }

    /*
    getPixelsFromYear(year, callback)
    {
        var holder = new PIXI.Container();
        this.pixi.stage.addChild(holder);

        var bg = new PIXI.Graphics();
        bg.beginFill(0xffcc00);
        bg.drawRect(0, 0, 140, 88);
        holder.addChild(bg);

        var pt = new PIXI.Text(year, {fontFamily : 'monospace', fontWeight:'bold', fontSize: 50, fill : 0xd1010f, align : 'left'});
        pt.x = 90 - (pt.width/2) - 19;
        pt.y = 44 - (pt.height/2);
        holder.addChild(pt);

        setTimeout(() => 
        {
            var pixels = this.restrictColours(
                this.pixi.renderer.plugins.extract.pixels(this.pixi.stage),
                this.textRestrictedColours
            );
            console.log(pixels);
            console.log(this.pixi.renderer.plugins.extract.base64(this.pixi.stage));
            callback(pixels);
        }, 200);
    }*/

    dualColours(pixels, safeColour, otherColour, maxDiff = 1000)
    {
        for(var i = 0; i < pixels.length; i+=4)
        {
            var diffR = safeColour.r - pixels[i];
            var diffG = safeColour.g - pixels[i+1];
            var diffB = safeColour.b - pixels[i+2];
            var diff = (diffR * diffR) + (diffG * diffG) + (diffB * diffB);
            
            if(Math.abs(diff) > maxDiff)
            {
                pixels[i] = otherColour.r;
                pixels[i+1] = otherColour.g;
                pixels[i+2] = otherColour.b;
            }
        }
        return pixels;
    }

    restrictColours(pixels, palette)
    {
        console.log(pixels);
        function mapColourToPalette(red, green, blue)
        {
            var colour, diffR, diffG, diffB, diffDistance, mappedColor;
            var distance = 25000;
            
            for(var i = 0; i < palette.length; i++)
            {
                colour = palette[i];
                diffR = (colour.r - red);
                diffG = (colour.g - green);
                diffB = (colour.b - blue);
                diffDistance = (diffR * diffR) + (diffG * diffG) + (diffB * diffB);

                if(diffDistance < distance)
                { 
                    distance = diffDistance; 
                    mappedColor = palette[i]; 
                };
            }

            if(!mappedColor)
            {
                mappedColor = {r:red, g:green, b:blue};
            }

            return mappedColor;
        }

        for(var i = 0; i < pixels.length; i+=4)
        {
            var rgb = mapColourToPalette(pixels[i], pixels[i+1], pixels[i+2]);
            pixels[i] = rgb.r;
            pixels[i+1] = rgb.g;
            pixels[i+2] = rgb.b;
        }

        return pixels;
    }


}